import React from 'react'
import { NotificationComponent } from '../../components'

const Notification = () => {
  return (
    <div>
      <NotificationComponent />
    </div>
  )
}

export default Notification
